import { useEffect, useState } from "react";
import { useParams } from "react-router";

import whatsappIcon from "@/assets/icons/whatsapp.svg";
import { Header } from "@/components/header";
import { Footer } from "../home/sections/footer";

import { ICompanyDetail } from "./types";
import "./styles.scss";

export const Support = () => {
  const [company, setCompany] = useState<ICompanyDetail | null>(null);
  const params = useParams();

  const fetchCompanyDetails = async (companyID?: string) => {
    if (!companyID) return;

    const apiURL = import.meta.env.VITE_URL_API;
    const response = await fetch(`${apiURL}/api/company/public/current`, {
      headers: {
        "X-Company-Id": companyID,
      },
    });

    const data = await response.json();

    setCompany(data as ICompanyDetail);
  };

  useEffect(() => {
    fetchCompanyDetails(params.companyId);
  }, [params.companyId]);

  const handleClickEmail = () => {
    window.open(`mailto:${company?.email}`);
  };

  const handleClickWhatsapp = () => {
    window.open(`https://wa.me/${company?.whatsapp}`);
  };

  return (
    <div className="support-wrapper">
      <Header />

      {company && (
        <div className="support-infos">
          <div className="support-infos__company_profile">
            <img
              src={company?.logo}
              alt={company?.name}
              className="support-infos__logo"
            />
          </div>

          <h4>Entre em contato conosco:</h4>
          <div className="support-infos__contact_list">
            {company?.whatsapp && (
              <div
                className="support-infos__contact_list--item"
                onClick={handleClickWhatsapp}
              >
                <img src={whatsappIcon} />
                <h4>Whatsapp</h4>
                <span>{company?.whatsapp}</span>
              </div>
            )}
            {company?.email && (
              <div
                className="support-infos__contact_list--item"
                onClick={handleClickEmail}
              >
                <i className="bx bx-envelope" />
                <h4>Email</h4>
                <span>{company?.email}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};
